import { render, staticRenderFns } from "./dialogEditPersonal.vue?vue&type=template&id=a85a6a2a"
import script from "./dialogEditPersonal.vue?vue&type=script&lang=js"
export * from "./dialogEditPersonal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports